import { combineReducers } from "redux";

import { reducer as activationReducer } from "./ActivationReducer";
import { reducer as appReducer } from "./InitAppReducer";
import { reducer as paymentReducer } from "./PaymentReducer";
import { reducer as productsReducer } from "./ProductsReducer";
import { reducer as userReducer } from "./UserReducer";

const reducers = combineReducers({
	app: appReducer,
	user: userReducer,
	payment: paymentReducer,
	activation: activationReducer,
	products: productsReducer,
});

export default reducers;
